/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ExportD8GridDashboardsD8GridExcelGet$Params {
  /**
   * ID проекта
   */
  project_id: number;

  /**
   * ID сценария; дефолт — активный
   */
  scenario_id?: number | null;
  from?: string | null;
  to?: string | null;
  granularity?: 'month' | 'year';
}

export function exportD8GridDashboardsD8GridExcelGet(
  http: HttpClient,
  rootUrl: string,
  params: ExportD8GridDashboardsD8GridExcelGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, exportD8GridDashboardsD8GridExcelGet.PATH, 'get');
  if (params) {
    rb.query('project_id', params.project_id, {});
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('granularity', params.granularity, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<any>;
    }),
  );
}

exportD8GridDashboardsD8GridExcelGet.PATH = '/dashboards/d8/grid/excel';
